import { H5 } from 'platform-components';
import React from 'react';

import './certificate-modal__form-title.scss';

interface Props {
    formTitleId: string;
}
export const CertificateModalFormTitle = ({ formTitleId }: Props) => (
    <div className="certificate-modal__form-title">
        <H5 id={formTitleId} />
    </div>
);
